import React from "react";

import { Table } from "react-bootstrap";

class SourcesConfigTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.sources.length) return null;

        return (
            <Table bordered responsive>
                <thead>
                    <tr>
                        <th>Source Code</th>
                        <th>Partner Name</th>
                        <th>Source Name</th>
                    </tr>
                </thead>
                <tbody>
                {
                    this.props.sources.map(({ code, name, partner_name }, id) => {
                        return (
                            <tr key={id}>
                                <td>{code}</td>
                                <td>{partner_name}</td>
                                <td>{name}</td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </Table>
        )
    }
}

export default SourcesConfigTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesConfig/components/Table/index.js